import React from "react";
import "../../HowItWorks/CallToActionSection/CallToActionSection.css"

const CallToActionSection = () => {
    return (
        <section className="_cTASectCont_x1A_" style={{marginTop:"5.3rem"}}>
            <div className="_cTASectContent_y2B_">
                <h2 className="_hTitle_s5E_ features-title" style={{marginBottom: "2rem"}}>
                    Ready to Support Your Community’s Needs?
                </h2>
                <p
                    className="workflow-subtitle _hSubtitle_t6F1_"
                    style={{
                        paddingTop: "0px",
                        marginTop: "0px",
                        paddingBottom: "0px",
                        marginBottom: "2rem",
                        width: "100%",
                        paddingLeft: "0",
                        paddingRight: "0"
                    }}
                >
                    Partner with Vanidya to make Satvik, Organic and ritual essentials easily accessible for your members. We work with groups of all sizes—housing societies, spiritual organizations and cultural associations—to create custom solutions for your dietary and religious preferences.
                </p>
                <div className="_cTAButtonsWrapper_b5E_">
                    <a href="/contact" className="_cTAButton_c6F_ _primaryCta_j7P_" aria-label="Partner with Vanidya">
                        Partner With Us
                        <svg className="cta-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                            <path d="M13 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </a>
                    <a
                        href="/faq"
                        className="_cTAButton_c6F_ _cBtn_k6C_ secondary-cta-button"
                    >
                        Read the FAQ
                    </a>
                </div>
            </div>
        </section>
    );
};

export default CallToActionSection;